import { post } from "@utils/httpUtil";
// 私域运营-分页查询计划列表
export function privateDomainOperatePlanFindPageByCondition(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/findPageByCondition`, data, config);
}
// 私域运营-根据计划ID查询计划
export function privateDomainOperatePlanFindById(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/findById`, data, config);
}
// 私域运营-查询私域运营计划列表数据
export function privateDomainOperatePlanFindPlanPageData(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/findPlanPageData`, data, config);
}
// 私域运营-查询运营计划统计数据
export function privateDomainOperatePlanFindPlanStatisticsData(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/findPlanStatisticsData`, data, config);
}
// 私域运营-发布计划
export function privateDomainOperatePlanPublish(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/publish`, data, config);
}
// 私域运营-删除计划
export function privateDomainOperatePlanRemove(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/remove`, data, config);
}
// 私域运营-停止计划
export function privateDomainOperatePlanStop(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/stop`, data, config);
}
// 私域运营-修改计划
export function privateDomainOperatePlanUpdate(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/update`, data, config);
}
// 私域运营-新建计划
export function privateDomainOperatePlanAdd(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/add`, data, config);
}
// 查询社区运营助手每日推送文章
export function operationAssistantDailyArticleList(data, config) {
  return post(`/c/pc/operationAssistant/dailyArticleList`, data, config);
}
// 查询社区运营助手开关配置
export function operateAssistantGetConfig(data, config) {
  return post(`/c/pc/operateAssistant/getConfig`, data, config);
}
// 编辑社区运营助手配置开关
export function operateAssistantUpdateConfig(data, config) {
  return post(`/c/pc/operateAssistant/updateConfig`, data, config);
}
// 查询社区运营助手账号管理
export function findOperateAssistantAccountManagement(data, config) {
  return post(`/c/pc/operateAssistant/findOperateAssistantAccountManagement`, data, config);
}
// 编辑社区运营助手账号管理配置
export function editOperateAssistantAccountManagement(data, config) {
  return post(`/c/pc/operateAssistant/editOperateAssistantAccountManagement`, data, config);
}
// 查询社区运营助手账号管理配置
export function getOperateAssistantAccountManagement(data, config) {
  return post(`/c/pc/operateAssistant/getOperateAssistantAccountManagement`, data, config);
}
// 查询企业微信绑定信息
export function weixinAuthQueryBind(data, config) {
  return post(`/c/pc/work/weixin/auth/queryBind`, data, config);
}
// 递归获取部门下的员工列表
export function workWeChatUserList(data, config) {
  return post(`/c/pc/work/weChat/userList`, data, config);
}
// 获取企业客户标签详情
export function workWeChatTagList(data, config) {
  return post(`/c/pc/work/weChat/list`, data, config);
}
// 私域运营-根据计划ID查询计划
export function findPlanTaskRecord(data, config) {
  return post(`/c/pc/privateDomainOperatePlan/findPlanTaskRecord`, data, config);
}